import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ListDropdown } from '@components/library/dropdown/index';
import { getUniqueValues } from '@api/v4/resources/custom_field_values';

const CustomFieldsSelector = ({
  advancedFiltersContainerRef,
  customFieldKeys,
  updateCustomFields
}) => {
  const [selectedKey, setSelectedKey] = useState(null);
  const [values, setValues] = useState([]); // list of unique values (strings)
  const [selectedValue, setSelectedValue] = useState(null);

  const formatKeyOptions = () => (
    customFieldKeys.map((option) => (
      { label: Object.keys(option)[0], value: Object.values(option)[0] }
    ))
  );

  const formatValueOptions = () => (
    values.map((value) => ({ label: value, value }))
  );

  const updateKey = (selection) => {
    if (selectedKey && selectedKey.value === selection.value) { return undefined; }

    setSelectedKey(selection);
    setSelectedValue(null);
    getUniqueValues(selection.value).then((response) => {
      setValues(response.custom_field_values);
    });

    return undefined;
  };

  const updateValue = (selection) => {
    if (selectedKey && selectedKey.value === selection.value) { return undefined; }

    setSelectedValue(selection);
    updateCustomFields(selectedKey.label, selection.value);
    setSelectedKey(null);
    setSelectedValue(null);
    return undefined;
  };

  return (
    <>
      <label className="bf-label bf-label--primary">{bfTranslate('Key')}</label>
      <ListDropdown
        className="custom-field-dropdown keys"
        onChange={updateKey}
        options={formatKeyOptions()}
        overflowParentRef={advancedFiltersContainerRef}
        placeholder={bfTranslate("Select Key")}
        searchable
        value={selectedKey}
      />
      {selectedKey && (
        <>
          <label className="bf-label bf-label--primary">{bfTranslate('Value')}</label>
          <ListDropdown
            className="custom-field-dropdown"
            onChange={updateValue}
            options={formatValueOptions()}
            overflowParentRef={advancedFiltersContainerRef}
            placeholder={selectedKey ? "Select Value" : ""}
            searchable
            value={selectedValue}
          />
        </>
      )}
    </>
  );
};

CustomFieldsSelector.propTypes = {
  advancedFiltersContainerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
  customFieldKeys: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updateCustomFields: PropTypes.func.isRequired,
};

export default CustomFieldsSelector;
